
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import OrderInfo from '../../views/order/details.vue'
  @Component({
    components: { OrderInfo },
    filters: {
      formatDate: function(value, type) {
        if (!value) {
          return
        }
        let date = new Date(value * 1000)
        let y: any = date.getFullYear()
        let MM: any = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d: any = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let h: any = date.getHours()
        let next_h = h < 10 ? ('0' + (h + 1)) : (h + 1)
        h = h < 10 ? ('0' + h) : h
        let m: any = date.getMinutes()
        m = m < 10 ? ('0' + m) : m
        let s: any = date.getSeconds()
        s = s < 10 ? ('0' + s) : s
        if (type == 1) {
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m + '-' + next_h + ':' + m
        } else if (type == 2) {
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m
        }
      }
    }
  })
export default class AddList extends Vue {
    @Prop() dialogAdd: boolean
    @Prop() student_info_id: string
    @Prop() is_show_student_info: boolean
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    studentId: any = ''
    getOrderList: any = []
    order_info_id: any = ''
    optionId: any = ''
    is_show_order_info: boolean = false
    is_model: boolean = false

    mounted() {
      this.order()
    }
    @Watch('is_show_student_info')
    getDetails(oldVal, newVal) {
      if(this.is_show_student_info) {
        this.order()
      } 
    }

    async handleClick(val) {
      const res:any = await CourseModule.getOptionId()
      const id = res.data.entity_id
      this.order_info_id = val.id
      this.optionId = id
      this.is_show_order_info = true
      // const url = `/customer/order?order_id=${val.id}&option_id=${id}`
      // this.$router.push({ path: url })
    }
    closeOrder() {
      this.is_show_order_info = false
    }
    async order() {
      const res:any = await CourseModule.getOrder({ 'student_id': this.student_info_id })
      if (res.code == 200) {
        this.getOrderList = []
        this.getOrderList.push(res.data)
      }
    }
}
